import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143bb372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[150px] mb-[104px] px-10" }
const _hoisted_2 = { class: "list" }

import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useGlobalStore } from '@/stores/global';
import SlideItem from '@/components/common/SlideItem.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Categories',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const globalStore = useGlobalStore();
const { categories, categoryTitle } = toRefs(globalStore);
const { getCategories } = globalStore;

const onNavigate = (id: number, title: string) => {
    categoryTitle.value = title;

    router.push({
        name: 'category',
        params: { id },
    });
};

const onLoad = async () => {
    if (!categories.value?.data.length) {
        await getCategories();
    }
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: _unref(t)('tours.title')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories)?.data, (category) => {
        return (_openBlock(), _createBlock(SlideItem, {
          key: category.id,
          id: category.id,
          title: category.attributes.title,
          text: category.attributes.subtitle,
          url: category.attributes.Cover.data?.attributes.url,
          onClick: ($event: any) => (onNavigate(category.id, category.attributes.title))
        }, null, 8, ["id", "title", "text", "url", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})